import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { MEIFormComponent } from './mei-form.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        MEIFormComponent
    ],
    exports: [
        MEIFormComponent
    ]
})
export class MEIFormModule { }
